import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=0b3996ac&scoped=true&"
import script from "@/views/Groups/Tabs/Notes.ts?vue&type=script&lang=ts&"
export * from "@/views/Groups/Tabs/Notes.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Groups/Tabs/notes.scss?vue&type=style&index=0&id=0b3996ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3996ac",
  null
  
)

export default component.exports